import React from "react";

const STATUS_CONFIG = {
  approved: {
    label: "Approved",
    bg: "#e8fbf8",
    border: "#1bc5bd",
    color: "#0e6251",
    dot: "#1bc5bd",
  },
  pending: {
    label: "Pending",
    bg: "#fff4de",
    border: "#ffa800",
    color: "#8a5a00",
    dot: "#ffa800",
  },
  rejected: {
    label: "Rejected",
    bg: "#ffe2e5",
    border: "#f64e60",
    color: "#901b27",
    dot: "#f64e60",
  },
  moreinfo: {
    label: "More Info",
    bg: "#eee5ff",
    border: "#8950fc",
    color: "#4a148c",
    dot: "#8950fc",
  },
  draft: {
    label: "Draft",
    bg: "#f3f6f9",
    border: "#dcdfe6",
    color: "#3f4254",
    dot: "#7e8299",
  },
};

const normalizeStatus = (raw) => {
  if (raw === 0 || raw === "0" || raw === "approved") return "approved";
  if (raw === 1 || raw === "1" || raw === "pending") return "pending";
  if (raw === 2 || raw === "2" || raw === "rejected") return "rejected";
  if (raw === 4 || raw === "4" || raw === "moreinfo") return "moreinfo";
  if (raw === 5 || raw === "5" || raw === "draft") return "draft";
  return String(raw || "pending").toLowerCase();
};

export function StatusColumnFormatter(
  cellContent,
  row,
  rowIndex,
  { updateStatus, processing, superadmin }
) {
  const currentKey = normalizeStatus(row.status);
  const currentStyle = STATUS_CONFIG[currentKey] || STATUS_CONFIG.pending;

  const callUpdateStatus = (newVal) => {
    if (newVal && newVal !== row.status) {
      updateStatus(row.id, newVal);
    }
  };

  if (processing === row.id) {
    return (
      <div className="d-inline-flex align-items-center py-1">
        <i className="fas fa-circle-notch fa-spin text-primary mr-2 font-size-sm"></i>
        <span className="font-size-xs text-muted">Updating...</span>
      </div>
    );
  }

  if (!superadmin) {
    return (
      <div className="d-inline-flex align-items-center text-nowrap">
        <span
          className="font-weight-bolder px-3 py-1"
          style={{
            fontSize: "11px",
            borderRadius: "14px",
            backgroundColor: currentStyle.bg,
            border: `1px solid ${currentStyle.border}`,
            color: currentStyle.color,
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <span
            style={{
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              backgroundColor: currentStyle.dot,
            }}
          ></span>
          {currentStyle.label}
        </span>
      </div>
    );
  }

  return (
    <div className="d-inline-flex align-items-center text-nowrap">
      <select
        value={currentKey}
        onChange={(e) => callUpdateStatus(e.target.value)}
        className="form-control form-control-sm font-weight-bolder"
        style={{
          fontSize: "11px",
          height: "28px",
          padding: "2px 8px",
          borderRadius: "14px",
          backgroundColor: currentStyle.bg,
          borderColor: currentStyle.border,
          color: currentStyle.color,
          cursor: "pointer",
          width: "auto",
          minWidth: "110px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        }}
        title="Change business status"
      >
        <option value="approved" style={{ backgroundColor: "#e8fbf8", color: "#0e6251" }}>
          ● Approved
        </option>
        <option value="pending" style={{ backgroundColor: "#fff4de", color: "#8a5a00" }}>
          ● Pending
        </option>
        <option value="rejected" style={{ backgroundColor: "#ffe2e5", color: "#901b27" }}>
          ● Rejected
        </option>
        <option value="moreinfo" style={{ backgroundColor: "#eee5ff", color: "#4a148c" }}>
          ● More Info
        </option>
        <option value="draft" style={{ backgroundColor: "#f3f6f9", color: "#3f4254" }}>
          ● Draft
        </option>
      </select>
    </div>
  );
}